import React from 'react';
import { Star } from 'lucide-react';
import { CTAButton } from '../CTAButton';
interface ReviewProps {
  rating: number;
  title: string;
  text: string;
  name: string;
  imageUrl?: string;
}
function ReviewCard({
  rating,
  title,
  text,
  name,
  imageUrl
}: ReviewProps) {
  return <div className="bg-gray-50 border border-gray-200 rounded-lg p-6 space-y-3" data-id="element-29">
      <div className="flex gap-1" data-id="element-30">
        {[...Array(rating)].map((_, i) => <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-31" />)}
      </div>
      <h4 className="font-bold text-gray-900 text-lg" data-id="element-32">{title}</h4>
      <p className="text-gray-700 leading-relaxed" data-id="element-33">"{text}"</p>
      <div className="flex items-center gap-3 pt-2" data-id="element-34">
        {imageUrl && <img src={imageUrl} alt={name} className="w-12 h-12 rounded-full object-cover" data-id="element-35" />}
        <p className="text-sm font-semibold text-gray-600" data-id="element-36">— {name}</p>
      </div>
    </div>;
}
export function CustomerReviews() {
  const reviews = [{
    rating: 5,
    title: 'Life-Changing Results',
    text: "I'm 65 and have tried everything—expensive creams, facial massage, you name it. This is the first thing that's actually made a visible difference. My wrinkles are noticeably reduced and my skin looks so much firmer. I get compliments constantly now!",
    name: 'Linda R., Verified User',
    imageUrl: 'https://cdn.shopify.com/s/files/1/0619/1693/8405/files/profilepic2_c1f00ae6-352d-4a7d-9ceb-e4b708316abd.png?v=1762472375'
  }, {
    rating: 5,
    title: 'Better Than My Dermatologist Visits',
    text: "I was spending $450 every 6 weeks at my dermatologist for microneedling treatments. This device gives me the same results at home for a fraction of the cost. It's paid for itself already.",
    name: 'Barbara H., Verified User',
    imageUrl: 'https://cdn.shopify.com/s/files/1/0619/1693/8405/files/profilepic1_369fd14f-289b-4e13-9a04-4eab5d210202.png?v=1762472376'
  }, {
    rating: 5,
    title: 'So Easy to Use!',
    text: "I was nervous about using needles on my face, but this is completely painless. Takes me 5 minutes once a month. My daughter said I look 10 years younger—and she's not one to give compliments!",
    name: 'Joyce M., Verified User',
    imageUrl: 'https://cdn.shopify.com/s/files/1/0619/1693/8405/files/profilepic4_81fcacdd-f29d-45d5-98a4-794f6c37a702.png?v=1762472376'
  }, {
    rating: 5,
    title: 'Results in ONE Hour',
    text: "I couldn't believe the difference after just one treatment. My skin was plumper, smoother, and had this glow I haven't seen in years. Three months in and I look better than I did at 60. I'm 68!",
    name: 'Sharon T., Verified User',
    imageUrl: 'https://cdn.shopify.com/s/files/1/0619/1693/8405/files/profilepic3_de818037-6086-45cc-926c-ff158dcb2b40.png?v=1762472376'
  }];
  return <div className="space-y-6" data-id="element-37">
      <h2 className="text-3xl font-bold text-gray-900 text-center" data-id="element-38">
        What Do Others Have To Say About This Device?
      </h2>
      <div className="grid md:grid-cols-2 gap-6" data-id="element-39">
        {reviews.map((review, index) => <ReviewCard key={index} {...review} data-id="element-40" />)}
      </div>
      <div className="py-4" data-id="element-41">
        <CTAButton data-id="element-42">APPLY DISCOUNT & CHECK AVAILABILITY</CTAButton>
      </div>
      
    </div>;
}